// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  contractId: __t.u64().primaryKey().name("contract_id"),
  issuer: __t.identity(),
  courier: __t.identity(),
  originKey: __t.string().name("origin_key"),
  destKey: __t.string().name("dest_key"),
  cargoJson: __t.string().name("cargo_json"),
  rewardSov: __t.i64().name("reward_sov"),
  collateralSov: __t.i64().name("collateral_sov"),
  state: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  acceptedAt: __t.timestamp().name("accepted_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
